<template>
  <div>





    <div class="flex flex-col md:flex-row md:justify-between">
      <inertia-link class="text-center btn-primary block" :href="route('my-orders.create')">
        <span>Place New Order</span>
      </inertia-link>

      <!--  TODO remove this when expired -->
      <promotion-link-button class="mt-3" expiry-date="2020-12-01" primary-text="AKBAR SCRATCH CODE !" action-text="Click here to send" link="https://bhm.mv"></promotion-link-button>

    </div>


    <div class="mt-8">
      <div class="bg-white shadow sm:rounded-lg">
        <div class="px-4 py-5 sm:p-6">

          <h3 class="text-lg leading-6 font-medium text-gray-900">
            Terms & Conditions
          </h3>
          <div class="mt-2 text-sm leading-5 text-gray-500 px-8" v-html="terms_conditions">

          </div>
        </div>
      </div>


    </div>

  </div>
</template>

<script>
import Layout from '@/Shared/Customers/Layout'
import DailyLimitNotice from '@/Shared/DailyLimitNotice'
import PromotionLinkButton from '@/Shared/PromotionLinkButton'

export default {
  metaInfo: { title: 'Dashboard' },
  layout: Layout,
  components: {DailyLimitNotice, PromotionLinkButton},
  props: {
    ordersClosed: Boolean,
    message: String,
    terms_conditions: String
  }
}
</script>
